export default 'https://tme.understood.org/assets/bundle_1.94e25416.vtt'